export class ValidatorHelper {

    static cpf(cpf) {
        if (typeof cpf !== 'string') return false
        cpf = cpf.replace(/[^\d]+/g, '')
        if (cpf.length !== 11 || !!cpf.match(/(\d)\1{10}/)) return false
        cpf = cpf.split('')
        const validator = cpf
            .filter((digit, index, array) => index >= array.length - 2 && digit)
            .map( el => +el )
        const toValidate = pop => cpf
            .filter((digit, index, array) => index < array.length - pop && digit)
            .map(el => +el)
        const rest = (count, pop) => (toValidate(pop)
            .reduce((soma, el, i) => soma + el * (count - i), 0) * 10) % 11 % 10
        return !(rest(10,2) !== validator[0] || rest(11,1) !== validator[1])
    }

    static cnpj(cnpj) {
        if(!cnpj.match(/^\d{2}\.\d{3}\.\d{3}\/\d{4}\-\d{2}$/)) {
            return false;
        }
        if (cnpj.length !== 18 || !!cnpj.match(/(\d)\1{13}/)) {
            return false
        }
        const match = cnpj.toString().match(/\d/g)
        const numbers = Array.isArray(match) ? match.map(Number) : []
        if (numbers.length !== 14) return false
        const items = [...new Set(numbers)]
        if (items.length === 1) return false
        const calc = (x) => {
            const slice = numbers.slice(0, x)
            let factor = x - 7
            let sum = 0
            for (let i = x; i >= 1; i--) {
                const n = slice[x - i]
                sum += n * factor--
                if (factor < 2) factor = 9
            }
            const result = 11 - (sum % 11)
            return result > 9 ? 0 : result
        }
        const digits = numbers.slice(12)
        const digit0 = calc(12)
        if (digit0 !== digits[0]) return false
        const digit1 = calc(13)
        return digit1 === digits[1]
    }
}
